document.querySelectorAll('[data-sst-faq-trigger]').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    const body = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!body) return;

    if (expanded) {
      trigger.setAttribute('aria-expanded', 'false');
      body.style.height = body.scrollHeight + 'px';
      requestAnimationFrame(() => {
        body.style.transition = 'height 0.3s cubic-bezier(0.2,0.7,0.3,1)';
        body.style.height = '0';
      });
      body.addEventListener('transitionend', () => {
        body.hidden = true;
        body.style.height = '';
        body.style.transition = '';
      }, { once: true });
    } else {
      trigger.setAttribute('aria-expanded', 'true');
      body.hidden = false;
      const h = body.scrollHeight;
      body.style.height = '0';
      body.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        body.style.transition = 'height 0.3s cubic-bezier(0.2,0.7,0.3,1)';
        body.style.height = h + 'px';
      });
      body.addEventListener('transitionend', () => {
        body.style.height = '';
        body.style.overflow = '';
        body.style.transition = '';
      }, { once: true });
    }
  });
});
